import type { ReactNode } from "react";
import { Icon } from "./icons";

export type SidebarItemStatus = "done" | "current" | "future";

export interface SidebarItemProps {
  num: number;
  title: ReactNode;
  sub?: ReactNode;
  status: SidebarItemStatus;
  active?: boolean;
  onClick?: () => void;
  disabled?: boolean;
}

export function SidebarItem({
  num,
  title,
  sub,
  status,
  active = false,
  onClick,
  disabled = false,
}: SidebarItemProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`group w-full grid grid-cols-[28px_1fr_16px] gap-3 items-start text-left py-3.5 px-1 border-b border-[var(--rule-2)] transition-colors ${disabled ? "opacity-40 cursor-not-allowed" : "hover:bg-[var(--paper-2)]"} ${active ? "bg-[var(--paper-2)]" : ""}`}
    >
      <span
        className={`step-num text-[16px] tabular ${active ? "text-[var(--ink)]" : "text-[var(--ink-4)]"}`}
      >
        {String(num).padStart(2, "0")}
      </span>
      <span className="min-w-0">
        <span
          className={`block text-[13px] font-medium leading-tight ${active ? "text-[var(--ink)]" : "text-[var(--ink-2)]"}`}
        >
          {title}
        </span>
        {sub && <span className="block caption mt-1">{sub}</span>}
      </span>
      <span className="flex justify-end items-center h-5">
        {status === "done" && (
          <Icon.Check size={12} strokeWidth={2.5} className="text-[var(--ink)]" />
        )}
        {status === "current" && (
          <span className="w-1.5 h-1.5 bg-[var(--ink)] rounded-full" />
        )}
      </span>
    </button>
  );
}
